export const percentFormatter = val => {
  const number = parseInt(val);

  if (isNaN(number))
    throw new Error(`Cannot format "${val}" as a percent, as it becomes NaN`);

  return `${number}%`;
};
